import { render } from "./ListView.vue?vue&type=template&id=52088050&scoped=true"
import script from "./ListView.vue?vue&type=script&lang=js"
export * from "./ListView.vue?vue&type=script&lang=js"

import "./ListView.vue?vue&type=style&index=0&id=52088050&lang=css"
import "./ListView.vue?vue&type=style&index=1&id=52088050&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52088050"]])

export default __exports__